import type { TComparisonRow, TComparisonValue } from "@/models/chat.model";

const ROW_LABELS: Record<string, string> = {
  price: "Price",
  availability: "Availability",
  discontinued: "Discontinued",
};

const humanizeKey = (key: string): string =>
  key.split(/[_-]/).map((word) => word[0]?.toUpperCase() + word.slice(1)).join(" ");

export const getComparisonRowLabel = (row: TComparisonRow): string =>
  row.name ?? ROW_LABELS[row.key] ?? humanizeKey(row.key);

export const formatComparisonValue = (rowKey: string, value: TComparisonValue): string => {
  if (value === null || value === undefined) return "—";

  if (rowKey === "price" && typeof value === "object") {
    return value.currency === "USD" ? `$${value.amount}` : `${value.amount} ${value.currency}`;
  }

  if (rowKey === "discontinued") return value ? "Yes" : "No";

  if (rowKey === "availability" && typeof value === "string") {
    return humanizeKey(value);
  }

  return String(value);
};
